export default __webpack_public_path__ + "static/media/l33.48205080.png";